<template>
    <BaseAccordion :accordion-ids="['insight']" class="inline-insight-accordion">
        <template #trigger-insight>
            <div class="flex items-center gap-2 text-left">
                <img :src="InsightGradientBar" alt="" class="w-1.5 h-6 rounded-full" aria-hidden="true" />
                <span class="body-small-semibold text-valence-grey-850">{{ insightTitle || firstSentence }}</span>
            </div>
        </template>
        <template #content-insight>
            <MarkdownText class="text-valence-grey-750 body-small px-2" :text="insightTitle ? (insight ?? '') : restOfInsight" />
        </template>
    </BaseAccordion>
</template>

<script setup lang="ts">
/**
 * Compact inline variant of ChatInsightAccordion, used inside ChatNadiaIntelligence
 * for per-turn insight display in the chat view. Composes BaseAccordion with
 * compact styling — follows the same pattern as ChatInsightAccordion and ChatMyPeopleAccordion.
 */
import InsightGradientBar from "~img/insight-gradient-bar.png";
import BaseAccordion from "~vue/components/BaseAccordion.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import type { ParseActionsInternalThinkingAction, ParseActionsValuesInsightAction } from "~vue/types/chat";
import { computed } from "vue";

type ChatInlineInsightAccordionProps = {
    data: ParseActionsInternalThinkingAction | ParseActionsValuesInsightAction;
};

const { data } = defineProps<ChatInlineInsightAccordionProps>();

const insightTitle = computed(() => data.action_params.short_title);

const insight = computed(() => data.action_params.final_response);

const firstSentence = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ")[0] + ".";
});

const restOfInsight = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ").slice(1).join(". ");
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";
/* FIXME: Update BaseAccordion to support a compact/minimal variant prop so these !important overrides aren't needed */
.inline-insight-accordion:deep() {
    .item {
        @apply shadow-none! bg-transparent!;
    }
    .trigger {
        @apply p-1! min-h-0!;
    }
    .content {
        @apply pl-5;
    }
}
</style>
